module.exports = __webpack_public_path__ + "img/4D.5347d506.svg";